import * as React from 'react';
import { renderSVGText } from './helpers/createSVGText';
import svgStyle from '../svg_style.less';

interface EntwicklungsplanBalkenProps extends React.ClassAttributes<any> {
    width: number;
    height: number;
    offset_y: number;
    offset_x: number;
    height_total: number;
    color: string;
    shifting?: number;
    plain_base?: boolean;
    text_color?: string;
    text_bottom_center?: boolean;
    text_bottom_offset_y?: number;
    text_bottom_value?: string;
    text_bottom_color?: string;
    text_content?: string;
    text_offset_x?: number;
    drawArrowhead?: boolean;
    columns_total?: number;
}

export class EntwicklungsplanBalken extends React.Component<EntwicklungsplanBalkenProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const width = this.props.width;
        const height = this.props.height;
        const offset_x = this.props.offset_x;
        const offset_y = this.props.offset_y;
        const height_total = this.props.height_total;
        const shifting = this.props.shifting ? this.props.shifting : 20;
        // Achtung, wir rechnen beim Diagramm von unten links, deshalb immer die he

        const punkt_unten_links = offset_x + ',' + (height_total - offset_y);
        const punkt_oben_links = offset_x + ',' + (height_total - (offset_y + height - shifting));
        const punkt_unten_rechts = this.props.plain_base
            ? (offset_x + width) + ',' + (height_total - (offset_y))
            : (offset_x + width) + ',' + (height_total - (offset_y + shifting));
        const punkt_oben_rechts = (offset_x + width) + ',' + (height_total - (offset_y + height));

        const points = punkt_unten_links + ' ' + punkt_oben_links + ' ' + punkt_oben_rechts + ' ' + punkt_unten_rechts + ' ' + punkt_unten_links;

        // Für Text
        const y_oben_links = height_total - (offset_y + height - shifting);
        const y_unten_links = (height_total - offset_y);
        const text_height = 20;
        const text_padding = 15;
        const text_offset_x = this.props.text_offset_x ? this.props.text_offset_x - text_padding : 0;
        // const points = '10,30 10,120 100,100 100,10 10,10';

        // const grad = offset_x / offset_y;
        // const ap_off = 25;
        // const ap_u_l = punkt_unten_rechts;
        // const ap_o_l = punkt_oben_rechts;
        // const ap_o_r = (offset_x + width + ap_off) + ',' + (height_total - offset_y - height + ap_off - 15);
        // const ap_u_r = (offset_x + width + ap_off + 1) + ',' + (height_total - offset_y - height + ap_off);
        // const ap_u = (offset_x + width + 10) + ',' + (height_total - offset_y - 17);
        // const pointsArrow = ap_u_l + ' ' + ap_o_l + ' ' + ap_o_r + ' ' + ap_u_r + ' ' + ap_u + ' ' + ap_u_l;

        const ap_u_l = punkt_unten_rechts;
        const ap_o_l = punkt_oben_rechts;
        const ap_m = offset_x + width + 20 + ',' + (height_total - offset_y - height + 17);
        const pointsArrow = ap_u_l + ' ' + ap_o_l + ' ' + ap_m;

        return (
            <g>
                <polygon
                    key={'test_poly'}
                    points={points}
                    className={svgStyle.testRect}
                    style={{ fill: this.props.color, stroke: this.props.color, strokeWidth: 1 }}
                />
                {this.props.text_content &&
                    renderSVGText(
                        this.props.text_content,
                        Math.ceil(width / 8),
                        15,
                        offset_x + text_padding,
                        y_oben_links + 10 + text_padding, width - text_padding * 2,
                        this.props.text_color
                    )
                }
                <text
                    x={this.props.text_bottom_center ? (offset_x + width / 2) : (offset_x + text_padding + text_offset_x)}
                    y={y_unten_links - text_padding + (this.props.text_bottom_offset_y ? this.props.text_bottom_offset_y : 0)}
                    style={{
                        fontWeight: 'bold',
                        fill: this.props.text_bottom_color ? this.props.text_bottom_color : '#fff'
                    }}
                    textAnchor={this.props.text_bottom_center ? 'middle' : 'start'}
                >
                    {this.props.text_bottom_value ? this.props.text_bottom_value : ''}
                </text>
                {this.props.drawArrowhead &&
                    <polygon
                        key={'poly_arrowhead'}
                        points={pointsArrow}
                        className={svgStyle.testRect}
                        style={{ fill: this.props.color, stroke: this.props.color, strokeWidth: 1 }}
                    />
                }
            </g>
        );
    }
}
